var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 37,
    rx: 4,
    fill: "#1847CA",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.75H25.5C26.8672 9.75 28 10.8828 28 12.25V24.75C28 26.1562 26.8672 27.25 25.5 27.25H10.5C9.09375 27.25 8 26.1562 8 24.75V12.25C8 10.8828 9.09375 9.75 10.5 9.75ZM25.5 16H10.5V24.75H25.5V16ZM25.0312 12.25H22.1797C21.9062 12.25 21.75 12.6016 21.9453 12.7969L23.3906 14.2422C23.5078 14.3594 23.7031 14.3594 23.8203 14.2422L25.2656 12.7969C25.4609 12.6016 25.3047 12.25 25.0312 12.25ZM13 17.5625H23C23.5078 17.5625 23.9375 17.9922 23.9375 18.5C23.9375 19.0469 23.5078 19.4375 23 19.4375H13C12.4531 19.4375 12.0625 19.0469 12.0625 18.5C12.0625 17.9922 12.4531 17.5625 13 17.5625ZM13 21.3125H23C23.5078 21.3125 23.9375 21.7422 23.9375 22.25C23.9375 22.7969 23.5078 23.1875 23 23.1875H13C12.4531 23.1875 12.0625 22.7969 12.0625 22.25C12.0625 21.7422 12.4531 21.3125 13 21.3125Z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDropdown);
export default __webpack_public_path__ + "static/media/list-dropdown.fc7ebe70e2e9d3283f319ab6845bea67.svg";
export { ForwardRef as ReactComponent };